import { createSelector } from 'reselect'
import * as R from 'ramda'

import { REPORT_FIELDS } from './constants'
import { entitySelector } from 'containers/Entity/selectors'

const skuSelector = (state) => state.report.greenlight.sku
const searchSelector = (state) => state.report.greenlight.search
const tableFilterSelector = (state) => state.report.greenlight.tableFilter
const tableSortSelector = (state) => state.report.greenlight.tableSort

const skuSourceSelector = createSelector(
  entitySelector,
  R.compose(
    R.fromPairs,
    R.map(({ name }) => [name, name]),
    R.ifElse(
      R.isNil,
      R.always([]),
      R.values
    ),
    R.prop('product_children_views')
  )
)

const mapPathToProp = R.curry((property, path, value) => 
  // try to find property if needed
  R.when(
    R.path(path),
    R.assoc(
      property,
      R.path(path)(value)
    )
  )(value)
)

const baseFormatters = [
  R.map(mapPathToProp('acousticIdle', ['winIdle0FanDb', 'max'])),
  R.map(mapPathToProp('acousticSingle', ['singleCardBoost0FanDb', 'max'])),
  R.map(mapPathToProp('acousticSli', ['sliCardTdp0FanDb', 'max'])),
  R.map(mapPathToProp('gpuTempIdle', ['winIdle0TGpu', 'max'])),
  R.map(mapPathToProp('gpuTempSingle', ['singleCardBoost0TGpu', 'max'])),
  R.map(mapPathToProp('gpuTempSli', ['sliCardTdp0TGpu', 'max']))
]

const a0Formatters = [
  R.map(mapPathToProp('acousticIdle', ['winIdle0FanDb', 'max'])),
  R.map(mapPathToProp('acousticSingle', ['singleCardBoostA0FanDb', 'max'])),
  R.map(mapPathToProp('acousticSli', ['sliCardTdpA0FanDb', 'max'])),
  R.map(mapPathToProp('gpuTempIdle', ['winIdle0TGpu', 'max'])),
  R.map(mapPathToProp('gpuTempSingle', ['singleCardBoostA0TGpu', 'max'])),
  R.map(mapPathToProp('gpuTempSli', ['sliCardTdpA0TGpu', 'max']))
]

const ada0Formatters = [
  R.map(mapPathToProp('acousticIdle', ['winIdle0FanDb', 'max'])),
  R.map(mapPathToProp('acousticSingle', ['singleCardBoostAda0FanDb', 'max'])),
  R.map(mapPathToProp('acousticSli', ['sliCardTdpAda0FanDb', 'max'])),
  R.map(mapPathToProp('gpuTempIdle', ['winIdle0TGpu', 'max'])),
  R.map(mapPathToProp('gpuTempSingle', ['singleCardBoostAda0TGpu', 'max'])),
  R.map(mapPathToProp('gpuTempSli', ['sliCardTdpAda0TGpu', 'max']))
]


const predicates = (query) => R.compose(
  R.anyPass,
  R.map(field => R.compose(
    R.contains(query),
    R.toLower,
    R.toString,
    R.prop(field)
  ))
)(REPORT_FIELDS)

const reportSourceSelector = createSelector(
  entitySelector,
  searchSelector,
  (entities, search) => R.compose(
    R.filter(predicates(search)),
    R.project(REPORT_FIELDS),
    ...baseFormatters,
    ...a0Formatters,
    ...ada0Formatters,
    R.ifElse(
      R.isNil,
      R.always([]),
      R.values
    ),
    R.prop('greenlight_report')
  )(entities)
)


export {
  skuSelector,
  searchSelector,
  tableFilterSelector,
  tableSortSelector,
  skuSourceSelector,
  reportSourceSelector
}
